import { cn, Tab, Tabs } from '@heroui/react';

import { useLogsViewUrlState, type LogsView } from '../../hooks';

import i18n from '~/common/helpers/i18n';

export type PipelineAgentLogsToggleProps = {
  className?: string;
};

export function PipelineAgentLogsToggle({
  className
}: PipelineAgentLogsToggleProps) {
  const { logsView, setLogsView } = useLogsViewUrlState();

  return (
    <Tabs
      aria-label={i18n.t('scenes.monitor.agentLogs.toggle.ariaLabel')!}
      variant='bordered'
      selectedKey={logsView}
      onSelectionChange={key => setLogsView(key as LogsView)}
      className={cn('w-fit', className)}
      classNames={{
        tabList: 'h-10 gap-1 p-1 bg-surface-container-low rounded-md relative',
        tab: 'h-8 px-2 text-base font-semibold data-[selected=true]:bg-surface data-[selected=true]:shadow-small rounded',
        tabContent:
          'text-on-surface-variant group-data-[selected=true]:text-on-surface'
      }}
      data-testid='monitor-logs-toggle'
    >
      <Tab
        key='pipeline'
        title={i18n.t('scenes.monitor.agentLogs.toggle.pipeline')!}
        data-testid='monitor-logs-toggle-pipeline'
      />
      <Tab
        key='agent'
        title={i18n.t('scenes.monitor.agentLogs.toggle.agent')!}
        data-testid='monitor-logs-toggle-agent'
      />
    </Tabs>
  );
}
